<i [ngClass]="cssIconColor" class="app-icon-share icon"></i>
<span *ngIf="shareTitle" class="share-title">{{ shareTitle | translate }}</span>
